// extracted by mini-css-extract-plugin
export default {"link":"Badge_link__tuhkZ","badge":"Badge_badge__ihtw3","wrapper":"Badge_wrapper__7EYqj","count":"Badge_count__GgGsa","text":"Badge_text__rw0OB"};